export default{
    lista:{
        method:'get',
        url:'desligamento/tabela/preco/lista?id={id}'
    },
    cadastra:{
        method:'post',
        url:'desligamento/tabela/preco/cadastro'
    },
    delete:{
        method:'delete',
        url:'desligamento/tabela/preco/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'desligamento/tabela/preco/editar{/id}'
    },
    update:{
        method:'post',
        url:'desligamento/tabela/preco/update'
    },
    cola:{
        method:'post',
        url:'tabelaprecorublica/cola'
    },
    pesquisa:{
        method:'get',
        url:'desligamento/tabela/preco/pesquisa?id={id}&tabela_preco_id={tabela_preco_id}'
    },
    
    eventodeleta:{
        method:'delete',
        url:'tabelaprecorublica/evento/deletar{/id}'
    },
    eventoupdate:{
        method:'put',
        url:'evento/update'
    },
}